import { useState, useEffect } from 'react';

export function useLanguage() {
  const [language, setLanguage] = useState('zh');

  useEffect(() => {
    // Detect browser language
    const browserLang = navigator.language || navigator.userLanguage;
    const initialLang = browserLang.startsWith('zh') ? 'zh' : 'en';
    setLanguage(initialLang);
  }, []);

  return { language, setLanguage };
}